import React from 'react';
import ReactDOM from 'react-dom';
import App from './config/routes/App';
import reportWebVitals from './reportWebVitals';
// import "./assets/styles/index.css";
/* eslint-disable global-require */
if (process.env.NODE_ENV !== 'production') {
  require('./assets/styles/index.css');
} else {
  require('./assets/styles/build.css');
}
/* eslint-disable global-require */

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
